export default {
  data() {
    return {
      titleHeader: [
        {
          label: "2PM",
          value: "Two_PM",
          full_title: "Two Point Made"
        },
        {
          label: "2PA",
          value: "Two_PA",
          full_title: "Two Point Attempt"
        },
        {
          label: "2P%",
          value: "Two_P%",
          full_title: "Two Point Percent"
        },
        {
          label: "3PM",
          value: "Three_PM",
          full_title: "Three Point Made"
        },
        {
          label: "3PA",
          value: "Three_PA",
          full_title: "Three Point Attempt"
        },
        {
          label: "3P%",
          value: "Three_P%",
          full_title: "Three Point Percentage"
        },
        {
          label: "FGM",
          value: "FGM",
          full_title: "Field Goals Made"
        },
        {
          label: "FGA",
          value: "FGA",
          full_title: "Field Goals Attempted"
        },
        {
          label: "FG%",
          value: "FG%",
          full_title: "Field Goals Percentage"
        },
        {
          label: "FTM",
          value: "FTM",
          full_title: "Free Throws Made"
        },
        {
          label: "FTA",
          value: "FTA",
          full_title: "Free Throws Attempted"
        },
        {
          label: "FT%",
          value: "FT%",
          full_title: "Free Throws Percentage"
        },
        {
          label: "PTS",
          value: "PTS",
          full_title: "Points"
        },
        {
          label: "AST",
          value: "AST",
          full_title: "Assists"
        },
        {
          label: "OREB",
          value: "OR",
          full_title: "Offensive Rebounds"
        },
        {
          label: "DREB",
          value: "DR",
          full_title: "Defensive Rebounds"
        },
        {
          label: "REB",
          value: "REB",
          full_title: "Rebounds"
        },
        {
          label: "BLK",
          value: "BLK",
          full_title: "Blocks"
        },
        {
          label: "STL",
          value: "STL",
          full_title: "Steals"
        },
        {
          label: "TO",
          value: "TO",
          full_title: "Turnovers"
        }
      ],
      statsHeader: [
        {
          label: "2PM",
          value: "2PM",
          full_title: "Two Point Made"
        },
        {
          label: "2PA",
          value: "2PA",
          full_title: "Two Point Attempt"
        },
        {
          label: "2P%",
          value: "2P%",
          full_title: "Two Point Percent"
        },
        {
          label: "3PM",
          value: "3PM",
          full_title: "Three Point Made"
        },
        {
          label: "3PA",
          value: "3PA",
          full_title: "Three Point Attempt"
        },
        {
          label: "3P%",
          value: "3P%",
          full_title: "Three Point Percentage"
        },
        {
          label: "FGM",
          value: "FGM",
          full_title: "Field Goals Made"
        },
        {
          label: "FGA",
          value: "FGA",
          full_title: "Field Goals Attempted"
        },
        {
          label: "FG%",
          value: "FG%",
          full_title: "Field Goals Percentage"
        },
        {
          label: "FTM",
          value: "FTM",
          full_title: "Free Throws Made"
        },
        {
          label: "FTA",
          value: "FTA",
          full_title: "Free Throws Attempted"
        },
        {
          label: "FT%",
          value: "FT%",
          full_title: "Free Throws Percentage"
        },
        {
          label: "PTS",
          value: "PTS",
          full_title: "Points"
        },
        {
          label: "AST",
          value: "AST",
          full_title: "Assists"
        },
        {
          label: "OREB",
          value: "OR",
          full_title: "Offensive Rebounds"
        },
        {
          label: "DREB",
          value: "DR",
          full_title: "Defensive Rebounds"
        },
        {
          label: "REB",
          value: "REB",
          full_title: "Rebounds"
        },
        {
          label: "BLK",
          value: "BLK",
          full_title: "Blocks"
        },
        {
          label: "STL",
          value: "STL",
          full_title: "Steals"
        },
        {
          label: "TO",
          value: "TO",
          full_title: "Turnovers"
        }
      ],
      filter: [
        {
          label: "ALL",
          value: "all"
        },
        {
          label: "FGM",
          value: "FGM"
        },
        {
          label: "FGA",
          value: "FGA"
        },
        {
          label: "FG%",
          value: "FG%"
        },
        {
          label: "3PM",
          value: "3PM"
        },
        {
          label: "3PA",
          value: "3PA"
        },
        {
          label: "3P%",
          value: "3P%"
        },
        {
          label: "FTM",
          value: "FTM"
        },
        {
          label: "FTA",
          value: "FTA"
        },
        {
          label: "FT%",
          value: "FT%"
        },
        {
          label: "OREB",
          value: "OR"
        },
        {
          label: "DREB",
          value: "DR"
        },
        {
          label: "REB",
          value: "REB"
        },
        {
          label: "AST",
          value: "AST"
        },
        {
          label: "STL",
          value: "STL"
        },
        {
          label: "BLK",
          value: "BLK"
        },
        {
          label: "TO",
          value: "TO"
        },
        {
          label: "PTS",
          value: "PTS"
        }
      ]
    };
  }
};
